import { useEffect, useState } from 'react'
import clsx from 'clsx'

import { Sheet, SheetContent } from './base'

export const SheetComp = ({
  defaultOpen = false,
  open,
  onOpenChange,
  children = null,
  className,
  closeIconClassName,
  style,
}: {
  defaultOpen?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
  children?: React.ReactNode
  className?: string
  closeIconClassName?: string
  style?: React.CSSProperties
}) => {
  const [openState, setOpenState] = useState(defaultOpen || open)

  useEffect(() => {
    setOpenState(open)
  }, [open])

  return (
    <Sheet
      open={openState}
      onOpenChange={(open) => {
        setOpenState(open)
        onOpenChange?.(open)
      }}
    >
      <SheetContent
        style={style}
        closeIconClassName={closeIconClassName}
        className={clsx('ds-min-w-[600px] ds-px-12 ds-pt-12', className)}
      >
        {children}
      </SheetContent>
    </Sheet>
  )
}
